import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Filtreeri / Reasta

  <span style="color:#85c1dc;">**FI:**</span>
  Järjestä / Lajittele

  <span style="color:#85c1dc;">**RU:**</span>
  Фильтр / Сортировка
*/
/* @__NO_SIDE_EFFECTS__ */
const m430 = msg(
  mf`Filtreeri / Reasta`,
  mf`Järjestä / Lajittele`,
  mf`Фильтр / Сортировка`,
)

export { m430 as 'w.module.filter_bar.filter_and_order' }